import { render, staticRenderFns } from "./ListaPromocoes.vue?vue&type=template&id=3751d644&scoped=true"
import script from "./ListaPromocoes.vue?vue&type=script&lang=js"
export * from "./ListaPromocoes.vue?vue&type=script&lang=js"
import style0 from "./ListaPromocoes.vue?vue&type=style&index=0&id=3751d644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3751d644",
  null
  
)

export default component.exports